module.exports = __webpack_public_path__ + "static/img/default_cover.7789c2c0.png";